import React, { useState, useEffect } from "react";

interface ImageGalleryProps {
  images: string[]; // Accept images as a prop
}

const ImageGallery: React.FC<ImageGalleryProps> = ({ images }) => {
  const [activeIndex, setActiveIndex] = useState<number>(0);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setActiveIndex((prevIndex) => (prevIndex + 1) % images.length); // Increment the index and loop back to 0 when we reach the end
    }, 10000); // Change the image every 10 seconds (10000 milliseconds)

    return () => clearInterval(intervalId); // Cleanup the interval when the component is unmounted
  }, [images.length]);

  const handleDotClick = (index: number) => {
    setActiveIndex(index);
  };

  return (
    <div className="relative w-full max-w-3xl border rounded-md overflow-hidden">
      {/* Container with padding to maintain 4:3 aspect ratio */}
      <div className="relative w-full pb-[70%]">
        {/* Dynamically rendered image */}
        {images.length > 0 && (
          <div className="absolute inset-0">
            <img
              src={images[activeIndex]}
              alt={`Slide ${activeIndex + 1}`}
              className="w-full h-full object-cover transition-all duration-500"
            />
          </div>
        )}
      </div>

      {/* Dots at the bottom */}
      <div className="absolute bottom-6 left-1/2 transform -translate-x-1/2 flex space-x-2">
        {images.map((_, index) => (
          <button
            key={index}
            onClick={() => handleDotClick(index)}
            className={`w-3 h-3 rounded-full ${
              index === activeIndex ? "bg-white" : "bg-gray-400"
            }`}
          />
        ))}
      </div>
    </div>
  );
};

export default ImageGallery;
